function _extends() {
  return (_extends = Object.assign || function(target) {
    var i, source, key;
    for (i = 1; i < arguments.length; i++) {
      source = arguments[i];
      for (key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }).apply(this, arguments);
}

function _ref(result, partial) {
  return _extends({}, result, partial);
}

function _ref2(ref) {
  var stale = ref.stale, data = ref.data, error = ref.error, extensions = ref.extensions, operation = ref.operation;
  return {
    fetching: !1,
    stale: !!stale,
    data: data,
    error: error,
    extensions: extensions,
    operation: operation
  };
}

function _ref3(val) {
  return val.fetching || val.stale;
}

function _ref$1(ref) {
  var stale = ref.stale, data = ref.data, error = ref.error, extensions = ref.extensions, operation = ref.operation;
  return {
    fetching: !1,
    stale: !!stale,
    data: data,
    error: error,
    extensions: extensions,
    operation: operation
  };
}

var CLIENT, getClient, setClient, initClient, mutate, initialState, query, subscription;

import { Client } from "@urql/core";

export * from "@urql/core";

import { subscribe, makeSubject, share, scan, switchMap, fromValue, concat, map, onStart, toPromise, take, skipWhile } from "wonka";

getClient = function() {
  return CLIENT;
};

setClient = function(client) {
  CLIENT = client;
};

initClient = function(args) {
  var client = new Client(args);
  setClient(client);
  return client;
};

mutate = function(args) {
  function mutate$(additionalArgs) {
    var mergedArgs = _extends({}, args, additionalArgs);
    return client.mutation(mergedArgs.query, mergedArgs.variables, mergedArgs.context).toPromise();
  }
  var client = getClient();
  mutate$.subscribe = function(onValue) {
    return subscribe(onValue)(client.mutation(args.query, args.variables, args.context)).unsubscribe;
  };
  mutate$.then = function(onValue) {
    return mutate$().then(onValue);
  };
  return mutate$;
};

initialState = {
  fetching: !1,
  stale: !1,
  error: void 0,
  data: void 0,
  operation: void 0,
  extensions: void 0
};

query = function(args) {
  var client = getClient(), ref = makeSubject(), args$ = ref.source, nextArgs = ref.next, queryResult$ = share(scan(_ref, initialState)(switchMap((function(args) {
    if (args.pause) {
      return fromValue({
        fetching: !1,
        stale: !1
      });
    }
    return concat([ fromValue({
      fetching: !0,
      stale: !1
    }), map(_ref2)(client.query(args.query, args.variables, _extends({}, {
      requestPolicy: args.requestPolicy,
      pollInterval: args.pollInterval
    }, args.context))), fromValue({
      fetching: !1,
      stale: !1
    }) ]);
  }))(args$))), queryStore = function(baseArgs) {
    function query$(args) {
      return queryStore(_extends({}, baseArgs, args));
    }
    var result$ = onStart((function() {
      nextArgs(_extends({}, baseArgs, args));
    }))(queryResult$);
    query$.subscribe = function(onValue) {
      return subscribe(onValue)(result$).unsubscribe;
    };
    query$.then = function(onValue) {
      return toPromise(take(1)(skipWhile(_ref3)(result$))).then(onValue);
    };
    return query$;
  };
  return queryStore(args);
};

subscription = function(args, handler) {
  var client = getClient(), ref = makeSubject(), args$ = ref.source, nextArgs = ref.next, subscriptionResult$ = share(scan((function(result, partial) {
    return _extends({}, result, partial, {
      data: void 0 !== partial.data ? "function" == typeof handler ? handler(result.data, partial.data) : partial.data : result.data
    });
  }), initialState)(switchMap((function(args) {
    if (args.pause) {
      return fromValue({
        fetching: !1,
        stale: !1
      });
    }
    return concat([ fromValue({
      fetching: !0,
      stale: !1
    }), map(_ref$1)(client.subscription(args.query, args.variables, args.context)), fromValue({
      fetching: !1,
      stale: !1
    }) ]);
  }))(args$))), subscriptionStore = function(baseArgs) {
    function subscription$(args) {
      return subscriptionStore(_extends({}, baseArgs, args));
    }
    function _ref2() {
      nextArgs(_extends({}, baseArgs, args));
    }
    subscription$.subscribe = function(onValue) {
      return subscribe(onValue)(onStart(_ref2)(subscriptionResult$)).unsubscribe;
    };
    return subscription$;
  };
  return subscriptionStore(args);
};

export { getClient, initClient, mutate, query, setClient, subscription };
//# sourceMappingURL=urql-svelte.mjs.map
